const getUnique = (field, votes) => {
    return Array.from(new Set(votes.map(vote => vote[field])));
};

export default getUnique;